(ns frontend.test.columns-modal.view
  "The test page of the Edit columns modal of the grid. It has a grid config in
   the state, and a button that opens the modal. There is no AG Grid on this
   page. A save changes the config, and the page shows it."
  (:require
   [cljs.pprint :as pprint]
   [re-frame.core :as rf]
   [reagent.core :as r]
   [ui.components.button.view :as button]
   [ui.view.grid-opensearch.columns-modal.event :as event]
   [ui.view.grid-opensearch.columns-modal.view :as columns-modal]
   [ui.view.grid-opensearch.model :as model]))

(def test-grid-id "columns-modal-test-grid")

(def sample-config
  {:columns        [[:oppo/name]
                    [:oppo/cur-ticket]
                    [:oppo/stage]
                    [:oppo/status]
                    [:oppo/owner]
                    [:oppo/target-asset :company/description]
                    [:oppo/target-asset :company/name]]
   :hidden-columns #{[:oppo/owner]
                     [:oppo/target-asset :company/name]}})

(rf/reg-event-db
 ::init
 (fn [db _]
   (-> db
       (assoc-in (model/config-full-path test-grid-id) sample-config)
       (assoc-in (model/entity-type-full-path test-grid-id) :entity.type/oppo))))

(rf/reg-sub
 ::config
 (fn [db _]
   (get-in db (model/config-full-path test-grid-id))))

(defn view
  []
  (r/with-let [_ (rf/dispatch-sync [::init])]
    (let [config @(rf/subscribe [::config])]
      [:div
       {:class "tw2 tw2-flex tw2-min-h-screen tw2-flex-col tw2-gap-6 tw2-bg-bg-primary tw2-p-4"}
       [:div
        {:class "tw2-flex tw2-flex-col tw2-gap-2"}
        [:h2
         {:class "tw2-text-lg tw2-font-semibold tw2-text-primary"}
         "Edit columns"]
        [:p
         {:class "tw2-text-sm tw2-text-secondary"}
         "The modal of the grid for the choice of the columns. The first column is locked."]
        [:div
         {:class "tw2-flex tw2-gap-2"}
         [button/component
          {:variant  :secondary
           :size     :sm
           :type     "button"
           :on-click (fn [_]
                       (rf/dispatch [::event/open test-grid-id]))}
          "Open the modal"]
         [button/component
          {:variant  :secondary
           :size     :sm
           :type     "button"
           :on-click (fn [_]
                       (rf/dispatch [::init]))}
          "Reset the config"]]]
       [:div
        {:class "tw2-flex tw2-flex-col tw2-gap-1"}
        [:h3
         {:class "tw2-text-base tw2-font-semibold tw2-text-primary"}
         "Config of the grid"]
        [:pre
         {:class "tw2-text-xs tw2-text-secondary"}
         (with-out-str (pprint/pprint config))]]
       [columns-modal/modal-view {:grid-id test-grid-id}]])))
